// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3epQJ","large":"styles_large__1YqTw"};